<script>
const { VUE_APP_API_HOST } = process.env

export default {
  methods: {
    listCatalogs() {
      return this.$http
        .get(`${VUE_APP_API_HOST}/catalogs`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`
          }
        })
        .then(res => res, err => err)
    },

    saveCatalog(body) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/catalogs`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`
          }
        })
        .then(res => res, err => err)
    },

    updateCatalog(data) {
      const { id, ...body } = data

      return this.$http
        .put(`${VUE_APP_API_HOST}/catalogs/${id}`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`
          }
        })
        .then(res => res, err => err)
    },

    deleteCatalog(id) {
      return this.$http
        .delete(`${VUE_APP_API_HOST}/catalogs/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`
          }
        })
        .then(res => res, err => err)
    }
  }
}
</script>